import React, {useEffect, useRef, useState} from 'react';
import VisitRequest from './components/VisitRequest';
import {FormattedMessage, useIntl} from "react-intl";
import {VisitRequestDto} from "../../../../../modules/vms/dto/VisitRequestDto";
import {HttpStatus} from "../../../../../modules/common/enums/HttpStatus";
import {VisitRequestApi} from "../../../../../modules/vms/api/VisitRequestApi";
import {MessageUtils} from "../../../../../utils/MessageUtils";
import {Button, Stack} from "@mui/material";
import SubmitButton from "../../../../../components/buttons/SubmitButton";
import {VisitRequestClassify} from "../../../../../modules/vms/enums/VisitRequestClassify";
import PageTitle from "../../../../../components/PageTitle";
import LoadingBackdrop from "../../../../../components/LoadingBackdrop";
import {ApplySourceType} from "../../../../../modules/vms/enums/ApplySourceType";
import VisitorList from "./components/VisitorList";
import {UserApi} from "../../../../../modules/account/api/UserApi";
import {UserDto} from "../../../../../modules/account/dto/UserDto";
import {ValidateUtils} from "../../../../../utils/ValidateUtils";
import {RequestVisitorDto} from "../../../../../modules/vms/dto/RequestVisitorDto";

const Index: React.FC = () => {
    const intl = useIntl();

    const [messageMap, setMessageMap] = useState(new Map<string, string>());

    const [visitRequest, setVisitRequest] = useState(new VisitRequestDto());
    const [currentUser, setCurrentUser] = useState(new UserDto());
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchSessionUser();
    }, []);

    const fetchSessionUser = async () => {
        const responseResult = await UserApi.getSessionUser();
        if (responseResult && responseResult.status === HttpStatus.SUCCESS) {
            setCurrentUser(responseResult.data);
            handleInitRequest(responseResult.data);
        }
    };

    const handleSubmit = async () => {
        if (!validate()) {
            return;
        }
        setLoading(true);
        for (let visitor of visitRequest.visitors) {
            if (visitor.attachFilesArray.length > 0) {
                visitor.attachFiles = JSON.stringify(visitor.attachFilesArray);
            }
        }
        const responseResult = await VisitRequestApi.inviteVisitRequest(visitRequest);
        if (responseResult.status === HttpStatus.SUCCESS) {
            MessageUtils.success(intl.formatMessage({id: 'VMS_VISIT_REQUEST_INVITE_SUCCESS'}));
            handleInitRequest(currentUser);
        }
        setLoading(false);
    };

    const handleInitRequest = (currentUser: UserDto) => {
        const newVisitRequest = new VisitRequestDto();
        newVisitRequest.applySourceType = ApplySourceType.Enum.EmployeeWeb;
        newVisitRequest.classify = VisitRequestClassify.Enum.Shipping;
        newVisitRequest.hostFullName = currentUser.fullName;
        newVisitRequest.hostMobile = currentUser.mobile;
        setVisitRequest(newVisitRequest);
    };

    const handleChange = (name: string, value: any) => {
        setVisitRequest({...visitRequest, [name]: value});
    };

    // const handleChangeVisitor = (name: string, value: any) => {
    //     setRequestVisitor({...requestVisitor, [name]: value});
    // };

    const validate = () => {
        const newMessageMap = new Map<string, string>();
        if (visitRequest.arriveStartDate === '' || visitRequest.arriveStartTime === '' || visitRequest.arriveEndDate === '') {
            newMessageMap.set('arriveStartDate', intl.formatMessage({id: 'VMS_VISIT_REQUEST_ARRIVE_TIME_REQUIRED'}));
        }
        if (visitRequest.purpose === '') {
            newMessageMap.set('purpose', intl.formatMessage({id: 'VMS_VISIT_REQUEST_PURPOSE_REQUIRED'}));
        }
        if (visitRequest.places.length <= 0) {
            newMessageMap.set('places', intl.formatMessage({id: 'VMS_VISIT_REQUEST_PLACES_REQUIRED'}));
        }
        if (visitRequest.visitors.length <= 0) {
            newMessageMap.set('visitors', intl.formatMessage({id: 'VMS_VISIT_REQUEST_VISITORS_REQUIRED'}));
        } else {
            validateVisitor(newMessageMap, visitRequest.visitors);
        }

        setMessageMap(newMessageMap);
        return newMessageMap.size <= 0;
    };

    const validateVisitor = (messageMap: Map<string, string>, visitors: Array<RequestVisitorDto>) => {
        for (let i = 0; i < visitors.length; i++) {
            const visitor = visitors[i];
            const messages = [];
            if (visitor.lastName === '') {
                messages.push(intl.formatMessage({id: 'VMS_REQUEST_VISITOR_LAST_NAME_REQUIRED'}));
            }
            if (visitor.firstName === '') {
                messages.push(intl.formatMessage({id: 'VMS_REQUEST_VISITOR_FIRST_NAME_REQUIRED'}));
            }
            if (visitor.mobile === '') {
                messages.push(intl.formatMessage({id: 'VMS_REQUEST_VISITOR_MOBILE_REQUIRED'}));
            } else if (!ValidateUtils.isMobileNumber(visitor.mobile)) {
                messages.push(intl.formatMessage({id: 'VMS_REQUEST_VISITOR_MOBILE_FORMAT_ERROR'}));
            }
            if (visitor.email && !ValidateUtils.isEmail(visitor.email)) {
                messages.push(intl.formatMessage({id: 'COMMON_EMAIL_FORMAT'}));
            }
            if (visitor.company === '') {
                messages.push(intl.formatMessage({id: 'VMS_REQUEST_VISITOR_COMPANY_REQUIRED'}));
            }
            if (visitor.plateNumber === '') {
                messages.push(intl.formatMessage({id: 'VMS_REQUEST_VISITOR_PLATE_NUMBER_REQUIRED'}));
            }
            if (messages.length > 0) {
                messageMap.set('visitors', 'No.' + (i + 1) + ':' + messages.join(','));
                break;
            }
        }
    };

    return (
        <div>
            <LoadingBackdrop open={loading} onClick={() => setLoading(false)}/>
            <PageTitle title={intl.formatMessage({id: 'VMS_VISIT_REQUEST_CLASSIFY_SHIPPING'})}/>
            <VisitRequest visitRequest={visitRequest} messageMap={messageMap} onChange={handleChange}
                          onChangeVisitRequest={(value) => setVisitRequest(value)}/>
            <br/>
            <VisitorList visitRequest={visitRequest} messageMap={messageMap} onChange={handleChange}/>
            <br/>
            <Stack direction={'row'} spacing={2} justifyContent={'center'} alignItems={'center'}>
                <SubmitButton onClick={handleSubmit}/>
            </Stack>
        </div>
    );
};

export default Index;
